import { ProductVariantViewModel, ProductViewModel } from '@/types/api'

export const getProductPricing = (
    productData: ProductViewModel | undefined,
    activeVariant: ProductVariantViewModel | undefined
) => {
    const basePrice = (activeVariant ? activeVariant.basePrice : productData?.basePrice) || 0
    const discountPercent = (activeVariant ? activeVariant.discountPercent : productData?.discountPercent) || 0
    const effectivePrice = (activeVariant ? activeVariant.salesPrice : productData?.salesPrice) || 0

    const isSalable = (activeVariant ? activeVariant?.isSalable : productData?.isSalable) || false

    return { basePrice, discountPercent, effectivePrice, isSalable }
}
